import dayjs from 'dayjs'
import Big from 'big.js'
// import cn from 'clsx'
import { formatMoney as formatMoneyC, formatDate as formatDate5 } from 'common/helpers'
import { Block, Text } from 'common/components'
import { isMilestonePassed } from '../helpers'
import styles from './BeforeAfter.variation.module.scss'

const formatDate = (date:string) => formatDate5(date, 'fifth')
const formatMoney= (n:number) => (('number' === typeof n)) ? formatMoneyC(n, {cents: true}) : '--'
const formatPercentage=(n:number) => (('number' === typeof n)) ? `${n}%` : '--'
const numberSign = (n:number) => (
  (n >= 0) ? '+':''
)
const showValue = (n:number|undefined, isVariation:boolean, isPercentage?:boolean) => (
  [
    `${!!isVariation ? numberSign(n) : ''}`,
    isPercentage ? `${formatPercentage(n)}` : `${formatMoney(n)}`
  ].join('')
)

export const BeforeAfterVariation:React.FC<any> = ({request, isConfirm}:{
  request: any
  isConfirm?: boolean
}) => {
  const project = request?.project || {}
  // console.log(request)
  // console.log(project)

  // const forecastPassed = isMilestonePassed(
  //   !isConfirm ? 'forecast-created':'forecast-confirmed',
  //   request
  // )
  const estFeePassed = isMilestonePassed(
    !isConfirm ? 'establish-fee-checked' : 'establish-fee-confirmed',
    request
  )
  const lineFeePassed = isMilestonePassed(
    !isConfirm ? 'line-fee-checked' : 'line-fee-confirmed',
    request
  )
  const fcltLmt2Passed = isMilestonePassed(
    !isConfirm ? 'facility-limit-2-checked' : 'facility-limit-2-confirmed',
    request
  )

  const variationDate       = !isConfirm ? request.startDate : request.startDateConfirmed

  const openDate            = project.openDate
  const maturityDateBefore  = project.maturityDate
  const loanAmountBefore    = project.totalAmount
  const estFeeBefore        = project.estFees
  const fLimit2Before       = project.facilityLimit2
  const interestBefore: any = project.currentInterestRate
  const lvrBefore           = project.lvr
  const lineFeeBefore:any   = project.totalFees
  const irrBefore:any       = project.xirr

  const maturityDateAfter   = !isConfirm ? request.maturityDate : request.maturityDateConfirmed

  const loanAmountAfter     = request.increaseAmount + loanAmountBefore
  const loanAmountVari      = request.increaseAmount
  
  const lineFeeAfter:any    = !lineFeePassed ? undefined : ( !isConfirm ? request.totalLineFees : (request.totalLineFeesConfirmed ?? request.totalLineFees))
  const lineFeeVari         = (('number' === typeof lineFeeAfter) && ('number' === typeof lineFeeBefore)) ? (Big(lineFeeAfter).sub(lineFeeBefore).toNumber()) : undefined

  const fLimit2After:any    = !fcltLmt2Passed ? undefined : ( !isConfirm ? request.facilityLimit2:request.facilityLimit2Confirmed )
  const fcLmt2Vari          = (('number' === typeof fLimit2After) && ('number' === typeof fLimit2Before)) ? (Big(fLimit2After).sub(fLimit2Before).toNumber()) : undefined
  
  const interestAfter       = request.interest
  const interestVari        = (('number' === typeof interestAfter) && ('number' === typeof interestBefore)) ? (Big(interestAfter).sub(interestBefore).toNumber()) : undefined

  const lvrAfter:any        = !fcltLmt2Passed ? undefined : (!isConfirm ? request.lvr : request.lvrConfirmed)
  const lvrVari             = (('number' === typeof lvrAfter) && ('number' === typeof lvrBefore)) ? (Big(lvrAfter).sub(lvrBefore).toNumber()) : undefined
  const irrAfter:any        = !fcltLmt2Passed ? undefined : (!isConfirm ? request.xirr : (request.xirrConfirmed || request.xirr))
  const irrVari             = (('number' === typeof irrAfter) && ('number' === typeof irrBefore)) ? (Big(irrAfter).sub(irrBefore).toNumber()) : undefined

  const estFeeVaria = !estFeePassed ? undefined : request.establishFeeAmount
  const estFeeAfter = (('number' === typeof estFeeVaria) && ('number' === typeof estFeeBefore)) ? Big(estFeeBefore).add(estFeeVaria).toNumber():undefined


  // console.table({ estFeeBefore, estFeeVaria })
  // console.table({ lineFeeBefore, lineFeeAfter })
  // console.table({ fLimit2Before, lineFeeAfter })

  return (
    !project?.uuid ? null :
    <div className={(styles.grid)}>
      <ParametersCard title="Before variation"
        openDate={openDate} maturityDate={maturityDateBefore}
        interest={interestBefore} lvr={lvrBefore} irr={irrBefore}
        loanAmount={loanAmountBefore}
        establishmentFee={estFeeBefore}
        lineFee={lineFeeBefore}
        facilityLimit2={fLimit2Before}
      />
      <ParametersCard title="Variation" isVariation
        variationDate={variationDate} maturityDays={dayjs(maturityDateAfter).diff(dayjs(maturityDateBefore), 'd')}
        interest={interestVari} lvr={lvrVari} irr={irrVari}
        loanAmount={loanAmountVari} 
        establishmentFee={estFeeVaria}
        lineFee={lineFeeVari}
        facilityLimit2={fcLmt2Vari}
      />
      <ParametersCard title="After variation" 
        openDate={openDate} maturityDate={maturityDateAfter}
        interest={interestAfter} lvr={lvrAfter} irr={irrAfter}
        loanAmount={loanAmountAfter}
        establishmentFee={estFeeAfter}
        lineFee={lineFeeAfter}
        facilityLimit2={fLimit2After}
      />
    </div>
  )
}

interface IParametersCardProps {
  isVariation?: boolean;
  title: string;
  openDate?: string;
  variationDate?: string;
  maturityDate?: string;
  maturityDays?: number;
  interest: number;
  lvr?: number;
  irr?: number;
  loanAmount?: number;
  establishmentFee?: number;
  lineFee?: number;
  facilityLimit2?: number;
}
const ParametersCard:React.FC<IParametersCardProps> = ({
  isVariation, title,
  openDate, variationDate,
  maturityDate, maturityDays,
  interest, lvr, irr,
  loanAmount, establishmentFee, lineFee, facilityLimit2,
}) => {
  const valueColor = !isVariation ? "black":"redError"
  return (
    <Block type={isVariation ? 'stone3':'card-bg'} className={styles['variation-parameters-card']}>
      <Text weight='medium' color="grayer" size="md">{title}</Text>
      <div className={styles['variation-parameters-card-row']}>
        { !!openDate &&
          <div>
            <Text weight='medium' color="grayer" size="xs">Open day</Text>
            <Text weight='demiBold' color="black" size="xl" mt={8}>
              {formatDate(openDate)}
            </Text>
          </div>
        }
        { !!variationDate &&
          <div>
            <Text weight='medium' color="grayer" size="xs">Variation day</Text>
            <Text weight='demiBold' color="black" size="xl" mt={8}>
              {formatDate(variationDate)}
            </Text>
          </div>
        }
        <div>
          <Text weight='medium' color="grayer" size="xs">Maturity day</Text>
          <Text weight='demiBold' color={valueColor} size="xl" mt={8}>
            { !!maturityDate ? 
              formatDate(maturityDate)
              :
              (!maturityDays) ? '+0'
              :
              `${numberSign(maturityDays)}${maturityDays} days`
            }
          </Text>
        </div>
      </div>
      <div className={styles['variation-parameters-card-row']}>
      <div>
        <Text weight='medium' color="grayer" size="xs">
          { !isVariation ? 'Approved loan amount' : 'Amount to be increased'}
        </Text>
        <Text weight='demiBold' color={(undefined === loanAmount) ? 'black':valueColor} size="xl" mt={8}>
          {showValue(loanAmount, isVariation)}
        </Text>
      </div>
      </div>
      <div className={styles['variation-parameters-card-row']}>
        <div>
          <Text weight='medium' color="grayer" size="xs">Establishment fee</Text>
          <Text weight='demiBold' color={(undefined === establishmentFee) ? "black":valueColor} size="xl" mt={8}>
            {showValue(establishmentFee, isVariation)}
          </Text>
        </div>
      </div>
      <div className={styles['variation-parameters-card-row']}>
        <div>
          <Text weight='medium' color="grayer" size="xs">Line fee</Text>
          <Text weight='demiBold' color={(undefined === lineFee) ? "black":valueColor} size="xl" mt={8}>
            {showValue(lineFee, isVariation)}
          </Text>
        </div>
      </div>
      <div className={styles['variation-parameters-card-row']}>
        <div>
          <Text weight='medium' color="grayer" size="xs">Facility limit 2</Text>
          <Text weight='demiBold' color={(undefined === facilityLimit2) ? "black":valueColor} size="xl" mt={8}>
            {showValue(facilityLimit2, isVariation)}
          </Text>
        </div>
      </div>
      <div className={styles['variation-parameters-card-row']}>
        <div>
          <Text weight='medium' color="grayer" size="xs">Interest</Text>
          <Text weight='demiBold' color={(undefined === interest) ? 'black': valueColor} size="xl" mt={8}>
            {showValue(interest, isVariation, true)}
          </Text>
        </div>
        <div>
          <Text weight='medium' color="grayer" size="xs">LVR</Text>
          <Text weight='demiBold' color={(undefined === lvr) ? "black":valueColor} size="xl" mt={8}>
            {showValue(lvr, isVariation, true)}
          </Text>
        </div>
        <div>
          <Text weight='medium' color="grayer" size="xs">IRR</Text>
          <Text weight='demiBold' color={(undefined === irr) ? "black":valueColor} size="xl" mt={8}>
            {showValue(irr, isVariation, true)}
          </Text>
        </div>
      </div>

    </Block>
  )
}
